// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__WNvOq","spin":"Spinner_spin__WmlHV"};